import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/Accordion';
import styled from 'styled-components';

const Section = styled.section`
  padding: ${props => props.theme.spacing['4xl']} 0;
  background-color: ${props => props.theme.colors.background.main};
  id: faq;
  
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    padding: 8rem 0;
  }
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing['2xl']};
`;

const ContentWrapper = styled.div`
  max-width: 48rem;
  margin: 0 auto;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const Subtitle = styled.span`
  color: ${props => props.theme.colors.accent.gold};
  font-weight: ${props => props.theme.typography.fontWeight.medium};
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-size: ${props => props.theme.typography.fontSize.sm};
`;

const Title = styled.h2`
  font-family: ${props => props.theme.typography.fontFamily.display};
  font-size: ${props => props.theme.typography.fontSize['4xl']};
  font-weight: ${props => props.theme.typography.fontWeight.bold};
  color: ${props => props.theme.colors.text.primary};
  margin-top: ${props => props.theme.spacing.lg};
  
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.typography.fontSize['5xl']};
  }
  
  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    font-size: ${props => props.theme.typography.fontSize['6xl']};
  }
  
  @media (min-width: ${props => props.theme.breakpoints.xl}) {
    font-size: ${props => props.theme.typography.fontSize['7xl']};
  }
  
  @media (min-width: ${props => props.theme.breakpoints['2xl']}) {
    font-size: ${props => props.theme.typography.fontSize['8xl']};
  }
`;

const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.lg};
`;

const StyledAccordionItem = styled(AccordionItem)`
  background-color: ${props => props.theme.colors.background.card};
  border: 1px solid ${props => props.theme.colors.border.main};
  border-radius: ${props => props.theme.borderRadius['2xl']};
  padding: 0 ${props => props.theme.spacing['2xl']};
  transition: ${props => props.theme.transitions.default};
  
  &[data-state='open'] {
    box-shadow: ${props => props.theme.shadows.elegant};
  }
`;

const FAQSection = () => {
  const { t } = useLanguage();

  const faqs = [
    {
      question: t('faq.q1'),
      answer: t('faq.a1'),
    },
    {
      question: t('faq.q2'),
      answer: t('faq.a2'),
    },
    {
      question: t('faq.q3'),
      answer: t('faq.a3'),
    },
  ];

  return (
    <Section id="faq">
      <Container>
        <ContentWrapper>
          <SectionHeader>
            <Subtitle>{t('faq.subtitle')}</Subtitle>
            <Title>{t('faq.title')}</Title>
          </SectionHeader>

          <Accordion type="single" collapsible>
            <AccordionWrapper>
              {faqs.map((faq, index) => (
                <StyledAccordionItem
                  key={index}
                  value={`item-${index}`}
                >
                  <AccordionTrigger>
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent>
                    {faq.answer}
                  </AccordionContent>
                </StyledAccordionItem>
              ))}
            </AccordionWrapper>
          </Accordion>
        </ContentWrapper>
      </Container>
    </Section>
  );
};

export default FAQSection;
